import { Controller } from "@hotwired/stimulus"
import EasyMDE from "easymde"

export default class extends Controller {
  connect() {
    this.editor = new EasyMDE({
      element: this.element,
      spellChecker: false,
      status: false,
      autoDownloadFontAwesome: false,
      toolbar: [
        "bold", "italic", "heading", "|",
        "unordered-list", "ordered-list", "|",
        "link", "table", "|",
        "preview", "side-by-side"
      ],
      minHeight: "300px"
    })
  }

  disconnect() {
    if (this.editor) {
      this.editor.toTextArea()
      this.editor = null
    }
  }
}
